import { BrowserRouter, Route, Switch } from 'react-router-dom';

// PAGINAS
import Home from './pages/Home';
import Canales from './pages/Canales';
import Cartelera from './pages/Cartelera';
import Ayuda from './pages/Ayuda';
import Dispositivos from './pages/Dispositivos';
import Planes from './pages/Planes';
import Guia from './pages/Guia';
import ScrollToTop from './pages/ScrollToTop';



const App = () => {

    return (

    <>

    <BrowserRouter>
        <Switch>
            <Route exact path="/" component={Home}></Route>
            <Route exact path="/canales" component={Canales}></Route>
            <Route exact path="/cartelera" component={Cartelera}></Route>
            <Route exact path="/dispositivos" component={Dispositivos}></Route>
            <Route exact path="/planes" component={Planes}></Route>
            <Route exact path="/guia" component={Guia}></Route>
            <Route exact path="/ayuda" component={Ayuda}></Route>
        </Switch>
        <ScrollToTop />
    </BrowserRouter>

    </>
)};

export default App;